import { createContext } from 'react';
import { parse } from 'node-html-parser';

const allowedTags = ['title', 'base', 'link', 'style', 'meta', 'script', 'template'];
const head = {};

const generateKey = (str) => {
	let h1 = 0xdeadbeef, h2 = 0x41c6ce57;
	for (let i = 0, ch; i < str.length; i++) {
		ch = str.charCodeAt(i);
		h1 = Math.imul(h1 ^ ch, 2654435761);
		h2 = Math.imul(h2 ^ ch, 1597334677);
	}

	h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
	h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
	h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
	h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

	return ((h2 >>> 0).toString(16).padStart(8, '0') + (h1 >>> 0).toString(16).padStart(8, '0'));
}

export const HeadContext = createContext({
	addHead: (html) => {
		const node = parse(html).firstChild;
		if (!node)return;
		const attributes = node.attributes;
		const allowed = (allowedTags.find((tag) => (tag.localeCompare(node.tagName, 'en-US', {sensitivity: 'base'}) === 0)) !== undefined);
		if (!allowed)return;
		const hashString = generateKey(`${node.tagName}-${Object.keys(attributes).sort().join('_')}-${Object.values(attributes).sort().join('_')}-${node.innerText}`);
		head[hashString] = node.toString();
	},

	getHead: () => Object.values(head),
});